import { FormControlLabel, Switch } from '@mui/material';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';

import { FormModalContainer } from '../../../../../design/dataTable/form/view/FormModalContainer';
import { FormActions } from '../../../../../design/form/FormActions';
import { FormAutocomplete } from '../../../../../design/form/FormAutocomplete';
import { FormTextArea } from '../../../../../design/form/FormTextArea';
import { FormTextField } from '../../../../../design/form/FormTextField';
import { VendorEntityModalDomain } from './VendorEntityModalDomain';

export interface IVendorEntityTableProperties {
  domain: VendorEntityModalDomain;
}

export const VendorEntityModal = observer(({ domain }: IVendorEntityTableProperties) => {
  useEffect(() => {
    domain.layoutDomain.setPageTitle(domain.ui.model.entity.id ? `Редактировать ` : `Добавить `);
  }, [domain]);
  return (
    <FormModalContainer onClose={domain.onCancelUpdates}>
      <VendorNameCustomFieldText domain={domain} />
      <VendorDescriptionCustomFieldArea domain={domain} />
      <VendorActiveStatusCustomSwitch domain={domain} />
      <VendorSystemTypeCustomField domain={domain} />
      <VendorOrderCustomFieldText domain={domain} />
      <FormActions onSave={() => domain.onSaveUpdates()} onCancel={() => domain.onCancelUpdates()} />
    </FormModalContainer>
  );
});

const VendorNameCustomFieldText = observer(({ domain }: { domain: VendorEntityModalDomain }) => {
  return (
    <FormTextField
      required={true}
      label={'Название'}
      value={domain.ui.model.entity.name}
      onChange={domain.getUpdateFieldHandler('name')}
      errorMessage={domain.getValidationErrorFor('name')?.message}
    />
  );
});

const VendorDescriptionCustomFieldArea = observer(({ domain }: { domain: VendorEntityModalDomain }) => {
  return (
    <FormTextArea
      required={true}
      label={'Описание'}
      value={domain.ui.model.entity.description}
      onChange={domain.getUpdateFieldHandler('description')}
      errorMessage={domain.getValidationErrorFor('description')?.message}
    />
  );
});

const VendorActiveStatusCustomSwitch = observer(({ domain }: { domain: VendorEntityModalDomain }) => {
  const [isChecked, setChecked] = useState(domain.ui.model.entity.isActive);

  const handleChange = (event: any) => {
    setChecked(event.target.checked);
    domain.ui.model.entity.isActive = event.target.checked;
  };
  useEffect(() => {
    setChecked(domain.ui.model.entity.isActive);
  }, [domain.ui.model.entity.isActive]);
  return (
    <FormControlLabel
      style={{ width: '100%', padding: '16px', margin: 0 }}
      control={<Switch color={'success'} checked={isChecked} onChange={handleChange} defaultChecked={true} />}
      label="Статус"
    />
  );
});

const VendorSystemTypeCustomField = observer(({ domain }: { domain: VendorEntityModalDomain }) => {
  const systemTypeValues = [
    ...domain.ui.systemTypes.list.map((category) => ({
      value: category,
      name: category,
    })),
  ];
  return (
    <FormAutocomplete
      required={true}
      label={'Системный тип'}
      selected={domain.ui.model.entity.systemType}
      values={systemTypeValues}
      onChangeSelect={(newValue: any) => {
        domain.ui.model.entity.systemType = newValue.value;
      }}
      errorMessage={domain.getValidationErrorFor('systemType')?.message}
    />
  );
});
const VendorOrderCustomFieldText = observer(({ domain }: { domain: VendorEntityModalDomain }) => {
  return (
    <FormTextField
      required={true}
      label={'Порядок'}
      type="text"
      value={domain.ui.model.entity.orderIndex?.toString()}
      onChange={domain.getUpdateIntegerFieldHandler('orderIndex')}
      errorMessage={domain.getValidationErrorFor('orderIndex')?.message}
      inputProps={{ maxLength: 9 }}
    />
  );
});
